import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { ShiftPlanGet, ShiftPlanService } from '@app/services/shift-plan.service';

@Component({
  selector: 'tt-shift-plan',
  templateUrl: './shift-plan.component.html',
  styleUrls: ['./shift-plan.component.css'],
  standalone: false,
})
export class ShiftPlanComponent implements OnInit {
    public page?: ShiftPlanGet;
    public saving = false;
    public deleting = false;
    constructor(
        private readonly shiftPlan: ShiftPlanService,
        private readonly modal: ModalService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        this.page = await this.shiftPlan.getPlan({ shiftplan_id: String(this.navigator?.params['shiftplan_id'] ?? '') });
    }

    public async saveChanges(): Promise<void> {
        if (!this.page || this.saving || this.deleting) return;
        this.saving = true;
        try { await this.shiftPlan.savePlan(this.page); await this.navigator?.back(); }
        finally { this.saving = false; }
    }

    public async deleteValues(): Promise<void> {
        if (!this.page || this.deleting || this.saving) return;
        this.deleting = true;
        try {
            if (!await this.modal.openConfirmDialog({ type: 'danger', title: 'confirm_title', translateTitle: true, message: 'confirm_message', translateMessage: true, ok: 'confirm_ok_label', cancel: 'confirm_cancel_label' })) return;
            await this.shiftPlan.deletePlan({ shiftplan_id: this.page.shiftplan_id });
            await this.navigator?.back();
        } finally { this.deleting = false; }
    }
}
